/**
 * Spread on an MUI <Alert> root to make the action slot stack below the body
 * at xs and sit beside it from sm up. Fixes the cramped two-line button label
 * pattern that the action slot produces on phone widths.
 */
export const responsiveAlertActionSx = {
  flexDirection: { xs: "column", sm: "row" },
  alignItems: { xs: "stretch", sm: "center" },
  "& .MuiAlert-action": {
    pl: { xs: 0, sm: 2 },
    pt: { xs: 1, sm: 0 },
    mr: { xs: 0, sm: -1 },
    width: { xs: "100%", sm: "auto" },
  },
} as const;
